export const getBaseURL = () => {
  return process.env.REACT_APP_AUTH_APP_BASE_URL;
};
